import * as Curry from "bs-platform/lib/es6/curry.js";
import * as Bolt0_list$Bolt0 from "bolt0/./bolt0_list.bs.js";
import * as Caml_builtin_exceptions from "bs-platform/lib/es6/caml_builtin_exceptions.js";

function Make(Record_param, Label) {
  var Private = {
    Record_param: Record_param,
    Label: Label
  };

  var columnNames = Curry._1(Label.named_exn, "columnNames");

  var distance = Curry._1(Label.named_exn, "distance");

  var data = Curry._1(Label.positional_exn, 1);

  var Label$1 = {
    columnNames: columnNames,
    distance: distance,
    data: data
  };

  var match = Curry._1(Record_param.R.of_alist,
  /* :: */
  [
  /* tuple */
  [columnNames,
  /* `List */
  [848054398,
  /* [] */
  0]],
  /* :: */
  [
  /* tuple */
  [distance,
  /* `String */
  [-976970511, "Euclidean"]],
  /* :: */
  [
  /* tuple */
  [data,
  /* `List */
  [848054398,
  /* [] */
  0]],
  /* [] */
  0]]]);

  var arg;

  if (match[0] >= 17724) {
    arg = match[1];
  } else {
    throw [Caml_builtin_exceptions.assert_failure,
    /* tuple */
    ["principal_coordinates.ml", 107, 32]];
  }

  var Default = {
    arg: arg
  };
  var Const = {
    Label: Label$1,
    Default: Default
  };
  var $$Error = {};

  var to_record = function to_record(columnNames$1, distance$1, data$1) {
    var match = Curry._1(Record_param.R.of_alist,
    /* :: */
    [
    /* tuple */
    [columnNames,
    /* `List */
    [848054398, Bolt0_list$Bolt0.map(function (x) {
      return (
        /* `String */
        [-976970511, x]
      );
    }, columnNames$1)]],
    /* :: */
    [
    /* tuple */
    [distance,
    /* `String */
    [-976970511, distance$1]],
    /* :: */
    [
    /* tuple */
    [data, data$1],
    /* [] */
    0]]]);

    if (match[0] >= 17724) {
      return match[1];
    } else {
      throw [Caml_builtin_exceptions.assert_failure,
      /* tuple */
      ["principal_coordinates.ml", 126, 28]];
    }
  };

  var columnNames$1 = Curry._2(Record_param.flag1, columnNames, Curry._1(Record_param.Flag.required, Curry._1(Record_param.Arg_type.list, Record_param.Arg_type.string)));

  var distance$1 = Curry._2(Record_param.flag1, distance, Curry._1(Record_param.Flag.required, Curry._1(Record_param.Arg_type.$$enum,
  /* :: */
  ["Euclidean",
  /* :: */
  ["Maximum",
  /* :: */
  ["Manhattan",
  /* :: */
  ["PearsonCorrelation",
  /* :: */
  ["SpearmanCorrelation",
  /* :: */
  ["KendallCorrelation",
  /* [] */
  0]]]]]])));

  var data$1 = Curry._2(Record_param.flag1, data, Curry._1(Record_param.Flag.required, Record_param.Arg_type.data));

  var of_record = function of_record(record, f) {
    var make = Curry.__3(f);

    var param = Curry._2(Record_param.Applicative_infix.$less$star$great, Curry._2(Record_param.Applicative_infix.$less$star$great, Curry._2(Record_param.Applicative_infix.$less$star$great, Curry._1(Record_param.$$return, make), Curry._1(Record_param.errs, columnNames$1)), Curry._1(Record_param.errs, distance$1)), Curry._1(Record_param.errs, data$1));

    return Curry._2(Record_param.parse, record, param);
  };

  var dataTypeAvailable = function dataTypeAvailable(type_) {
    if (type_ !== 3654863) {
      return type_ === 365180284;
    } else {
      return true;
    }
  };

  var explainedVariance = Curry._1(Label.named_exn, "explainedVariance");

  var vectors = Curry._1(Label.named_exn, "vectors");

  var labels = Curry._1(Label.named_exn, "labels");

  var Label$2 = {
    explainedVariance: explainedVariance,
    vectors: vectors,
    labels: labels
  };
  var Const$1 = {
    Label: Label$2
  };
  var $$Error$1 = {};

  var explainedVariance$1 = Curry._2(Record_param.flag1, explainedVariance, Curry._1(Record_param.Flag.required, Curry._1(Record_param.Arg_type.array, Record_param.Arg_type.$$float)));

  var vectors$1 = Curry._2(Record_param.flag1, vectors, Curry._1(Record_param.Flag.required, Curry._1(Record_param.Arg_type.array, Curry._1(Record_param.Arg_type.array, Record_param.Arg_type.$$float))));

  var labels$1 = Curry._2(Record_param.flag1, labels, Curry._1(Record_param.Flag.required, Curry._1(Record_param.Arg_type.array, Record_param.Arg_type.string)));

  var Param = {
    explainedVariance: explainedVariance$1,
    vectors: vectors$1,
    labels: labels$1
  };

  var of_record$1 = function of_record$1(record, f) {
    var make = Curry.__3(f);

    var param = Curry._2(Record_param.Applicative_infix.$less$star$great, Curry._2(Record_param.Applicative_infix.$less$star$great, Curry._2(Record_param.Applicative_infix.$less$star$great, Curry._1(Record_param.$$return, make), Curry._1(Record_param.errs, explainedVariance$1)), Curry._1(Record_param.errs, vectors$1)), Curry._1(Record_param.errs, labels$1));

    return Curry._2(Record_param.parse, record, param);
  };

  var T = {
    Const: Const$1,
    $$Error: $$Error$1,
    Param: Param,
    of_record: of_record$1
  };
  return {
    Private: Private,
    Arg: {
      Const: Const,
      $$Error: $$Error,
      Param: {
        columnNames: columnNames$1,
        distance: distance$1,
        data: data$1
      },
      to_record: to_record,
      of_record: of_record,
      dataTypeAvailable: dataTypeAvailable
    },
    T: T
  };
}

export { Make };
/* No side effect */